import script from "./AutoLock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoLock.vue?vue&type=script&setup=true&lang=ts"

import "./AutoLock.vue?vue&type=style&index=0&id=c6d04066&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6d04066"]])

export default __exports__